import { CircleHelp } from 'lucide-react'
import { text, type Locale } from '../i18n'

const SUPPORT_EMAIL = 'support@v8ce.com'

export default function SiteFooter({
  locale,
  onOpenCapabilities,
}: {
  locale: Locale
  onOpenCapabilities: () => void
}) {
  return (
    <footer>
      <span>Frame Local · Private Media Kit</span>
      <button onClick={onOpenCapabilities} type="button">
        <CircleHelp size={15} />
        {text(locale, 'browserSupport')}
      </button>
      <span className="footer-contact">
        {text(locale, 'contact')}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </span>
      <span>{text(locale, 'browserRecommended')}</span>
    </footer>
  )
}
